import React from 'react';
import { X } from 'lucide-react';

type TagVariant = 'default' | 'brand' | 'success' | 'danger';

export interface TagProps {
  label: string;
  onRemove?: () => void;
  variant?: TagVariant;
  className?: string;
}

const VARIANT_STYLES: Record<TagVariant, string> = {
  default: 'px-2.5 py-1 bg-surface-secondary text-content-secondary border border-subtle',
  brand: 'px-2.5 py-1 bg-brand/10 text-brand border border-brand/20',
  success: 'px-2.5 py-1 bg-emerald-400/10 text-emerald-400 border border-emerald-400/20',
  danger: 'px-2.5 py-1 bg-red-400/10 text-red-400 border border-red-400/20',
};

const Tag = React.forwardRef<HTMLSpanElement, TagProps>(
  (
    {
      label,
      onRemove,
      variant = 'default',
      className = '',
    },
    ref,
  ) => {
    const baseClasses = [
      'inline-flex items-center gap-1.5 rounded-lg text-xs font-medium',
      VARIANT_STYLES[variant],
      className,
    ].filter(Boolean).join(' ');

    return (
      <span ref={ref} className={baseClasses}>
        {label}
        {onRemove && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onRemove();
            }}
            className="p-0.5 rounded hover:bg-surface-primary/50 transition-colors cursor-pointer"
            aria-label={`Remove ${label}`}
          >
            <X size={12} />
          </button>
        )}
      </span>
    );
  },
);

Tag.displayName = 'Tag';

export default Tag;
